import React from 'react';
import { Box, Typography } from '@mui/material';

function BookListFooter() {
  return (
    <Box sx={{ 
      bgcolor: 'background.paper', 
      borderTop: 1, 
      borderColor: 'divider',
      py: 2,
      mt: 4
    }}>
      <Box sx={{ 
        maxWidth: 'lg', 
        mx: 'auto', 
        textAlign: 'center' 
      }}>
        <Typography variant="body2" color="text.secondary">
          © 2024 BookPort - Your Book Collection Manager
        </Typography>
      </Box>
    </Box>
  );
}

export default BookListFooter; 